
import styles from './Pagination.module.scss'
import React, {MouseEventHandler} from "react";
import {Article} from "@/types/Article.d";

// interface TileProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
//     person: Person
// }

/**
 * Always keep 2 pages before and after current, and first and last
 * @param pagination
 * @constructor
 */
export default function Pagination({page: pageStr, pages, onChange}: {
  page: string|number,
  pages: number,
  onChange: (page: number) => void
}) {


  const currentPage = parseInt(String(pageStr))


  if (pages <= 1){
    return <></>
  }
  const min = Math.max(currentPage - 2, 2);
  const max = Math.min(currentPage + 2, pages-1);
  const urls: number[] = [];

  for (let i = min; i <= max; i++){
    urls.push(i)
  }

  const handleClick = (e: any, page: number) => {
    e.preventDefault();
    if (page !== currentPage) {
      onChange(page)
    }

  }
  // &#171; &#187;

  return <div className={`${styles.pagination} `}>
    {currentPage > 1 && <span className={styles.link} onClick={(e) => handleClick(e, currentPage-1)}>Vorige</span>}
    {pages > 1 && <span className={currentPage === 1 ? styles.current : styles.link} onClick={(e) => handleClick(e, 1)}>1</span>}
    {urls[0] > 2 && <span className={styles.dots}>&#8230;</span>}

    {urls.map((url, index) => currentPage === url ?
      <span key={index} className={styles.current}>{url}</span> :
      <span key={index} className={styles.link} onClick={(e) => handleClick(e, url)}>{url}</span>
    )}

    {urls[urls.length -1]  + 1 < pages && <span className={styles.dots}>&#8230;</span>}
    {pages > 1 && <span className={currentPage === pages ? styles.current : styles.link} onClick={(e) => handleClick(e, pages)}>{pages}</span>}
    {currentPage < pages && <span className={styles.link} onClick={(e) => handleClick(e, currentPage+1)}>Volgende</span>}

  </div>
}
